import { render, staticRenderFns } from "./CodPostal.vue?vue&type=template&id=f46c1976&"
import script from "./CodPostal.vue?vue&type=script&lang=js&"
export * from "./CodPostal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports